import { render, staticRenderFns } from "./EditOrCreate.vue?vue&type=template&id=fda68758&"
import script from "./EditOrCreate.vue?vue&type=script&lang=js&"
export * from "./EditOrCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports